// extracted by mini-css-extract-plugin
export var standaloneTable = "_f6-0";
export var standaloneTableWithBodyFill = "_f6-1";
export var withExtraHeader = "_f6-2";